export default "__VITE_ASSET__DIn6xnqf__"